// eslint-disable-next-line import/no-extraneous-dependencies
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { IconButton, Tooltip } from '@mui/material';

interface InfoLinkProps {
  href: string;
  tooltipText?: string;
  sx?: any;
}

const InfoLink = ({ href, tooltipText = 'View Documentation', sx }: InfoLinkProps) => (
    <Tooltip title={tooltipText}>
      <IconButton
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        size="small"
        sx={{ ...sx }}
      >
        <MenuBookIcon fontSize="small" color='info' />
      </IconButton>
    </Tooltip>
  );

export default InfoLink;
